import { ToastType, UseToast } from "@/components/root/toast/toast.state";

const force_download = (file_name: string, url_content: string) => {
  const a = document.createElement("a");
  a.style.display = "none";
  a.href = url_content;
  a.download = file_name.replace(/ /g, "_");
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url_content);
  a.remove();
};

const downloadFile = (accept: string) => (payload: {
  authorization: string;
  fileName: string;
  filePath: string;
  use_auth?: boolean;
}): [string, () => Promise<void>] => {
  const { authorization, fileName, filePath, use_auth = false } = payload;

  const download = async () => {
    const { SharedState } = await import("@/common/state");
    if (SharedState.env.value.env === "uat") {
      const url = window.URL.createObjectURL(new Blob(["some content"]));
      force_download(fileName, url);
      return;
    }

    const headers = { accept };
    if (use_auth) {
      // @ts-ignore
      headers.authorization = authorization;
    }
    try {
      const resp = await fetch(filePath, {
        headers,
      });
      const blob = await resp.blob();
      const url = window.URL.createObjectURL(blob);
      force_download(fileName, url);
    } catch (e) {
      console.log(`error downloading ${accept} file :`);
      UseToast().show({
        type: ToastType.ALERT,
        msg: `error while downloading ${accept} file`,
        duration: 3000,
      });
    }
  };

  return [fileName, download];
};

export const DownloadService = {
  from_str: (content: string, file_name: string) => {
    const url = window.URL.createObjectURL(new Blob([content]));
    force_download(file_name, url);
  },
  from_web: {
    pdf: downloadFile("application/pdf"),
    csv: downloadFile("text/csv"),
    zip: downloadFile("application/zip"),
    pptx: downloadFile(
      "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    ),
  },
};
